import { render, staticRenderFns } from "./SpecialInterestInfo.vue?vue&type=template&id=b8c0fd5e"
import script from "./SpecialInterestInfo.vue?vue&type=script&lang=js"
export * from "./SpecialInterestInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports